var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 122"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 25,
    cy: 25,
    r: 24.25,
    fill: "white",
    stroke: "#EF8933",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M38.165 25.3618H13.165",
    stroke: "#EF8933",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M18.3613 19L11.9995 25.3618L18.3613 31.7237",
    stroke: "#EF8933",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prevIcon.871dfc7f805168ddb5642727ab719c23.svg";
export { ForwardRef as ReactComponent };